import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '../ApiService/api.service';

@Injectable({
  providedIn: 'root'
})
export class StatesDistrictsService {

  constructor(
    private http: ApiService
  ) { }

  states(): Observable<any> {
    const getStatesUrl = `${environment.base_url + '/states'}`;
   return this.http.get(getStatesUrl);
  }
  tempStates(): Observable<any> {
    const getStatesUrl = `${environment.base_url + '/apprenticeship-mela/get-pmnam-state-districts'}`;
   return this.http.post(getStatesUrl);
  }

  allDistricts(): Observable<any> {
    const getDistricsUrl = `${environment.base_url + '/districts'}`;
   return this.http.get(getDistricsUrl);
  }

  districts(id: any): Observable<any> {
    const getDistrictsUrl = `${environment.base_url  + '/states/' + id + '/districts'}`;
    return this.http.get(getDistrictsUrl);
  }
  tempDistricts(id: any): Observable<any> {
    let data = {
      state_id : id
    }
    const getDistrictsUrl = `${environment.base_url  + '/apprenticeship-mela/get-pmnam-state-districts'}`;
    return this.http.post(getDistrictsUrl,data);
  }
  districtsView(): Observable<any> {
    const getDistrictViewsUrl = `${environment.base_url + '/districts'}`;
    return this.http.get(getDistrictViewsUrl);
  }
  tilesData(year?:any, month?:any){
    const getTilesUrl = `${environment.base_url}/apprenticeship-mela/pmnam-dashboard?year=${year}&month=${month}`;
    return this.http.get(getTilesUrl);
  }
  PMNAMstates(data): Observable<any> {
		const getStatesUrl = `${environment.base_url + '/apprenticeship-mela/get-pmnam-state-districts'}`;
   return this.http.post(getStatesUrl,data);
  }
  PMNAMdistricts(year:any,month:any,state_id:any): Observable<any> {
		const getStatesUrl = `${environment.base_url + '/apprenticeship-mela/get-pmnam-state-districts?'  + 'year=' + year + '&month=' + month + '&state_id=' + state_id }`;
   return this.http.post(getStatesUrl);
  }
  PMNAMcentre(year:any,month:any,state_id:any,district_id:any): Observable<any> {
		const getStatesUrl = `${environment.base_url + '/apprenticeship-mela/get-pmnam-state-districts?'  + 'year=' + year + '&month=' + month + '&state_id=' + state_id + '&district_id=' + district_id}`;
   return this.http.post(getStatesUrl);
  }

  PMNAMdistrictsByName(year:any,month:any,state_name:any): Observable<any> {
		const getStatesUrl = `${environment.base_url + '/apprenticeship-mela/get-pmnam-state-districts?'  + 'year=' + year + '&month=' + month + '&state_name=' + state_name }`;
   return this.http.post(getStatesUrl);
  }
  PMNAMcentreByStateName(formData): Observable<any> {
		const getStatesUrl = `${environment.base_url + '/apprenticeship-mela/get-pmnam-state-districts'}`;
   return this.http.post(getStatesUrl,formData);
  }
  getNews(): Observable<any> {
		const getStatesUrl = `${environment.base_url + '/apprenticeship-mela/get-news?page_size=10'}`;
   return this.http.get(getStatesUrl);
  }
  getNotice(state_name,district_id): Observable<any> {
		const getStatesUrl = `${environment.base_url + '/apprenticeship-mela/get-all-notice?' + 'state_name='+state_name + '&district_id='+district_id}`;
   return this.http.get(getStatesUrl);
  }
  getParticipatingEst(district_id): Observable<any> {
		const getStatesUrl = `${environment.base_url + '/apprenticeship-mela/get-location-wise-opportunities?'+ 'district_id='+district_id}`;
   return this.http.get(getStatesUrl);
  }
}
